// Angular
import { Injectable } from '@angular/core';

// Libraries
import { Subject } from 'rxjs';

// Models
import { AppCleanup } from '../../../../../shared/models';

// Enums

@Injectable({
	providedIn: 'root',
})
export class CompletedJobService extends AppCleanup {
	private triggerSearchVar = new Subject<void>();
	triggerSearch$ = this.triggerSearchVar.asObservable();

	private showJDRDownloadVar = new Subject<boolean>();
	showJDRDownload$ = this.showJDRDownloadVar.asObservable();

	private triggerJDRDownloadVar = new Subject<void>();
	triggerJDRDownload$ = this.triggerJDRDownloadVar.asObservable();

	constructor() {
		super();
	}

	triggerSearch() {
		this.triggerSearchVar.next();
	}

	triggerJDRDownload() {
		this.triggerJDRDownloadVar.next();
	}

	toggleShowJDRDownload(show: boolean) {
		this.showJDRDownloadVar.next(show);
	}
}
